import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent {
    @Input() flavor = '';
    @Input() symbol = '';
    @Input() pulse = false;

    constructor() {
    }

    public get isSymbol(): boolean {
        return !!this.symbol;
    }

}
